module.exports = __webpack_public_path__ + "img/warning-icon.9672b73.svg";